import React from "react";
import { Grid, MenuItem, Paper } from "@mui/material";
import { FormInput } from "../../../../components/input/FormInput";

const TrabajoSection = ({
  tiposDireccion,
  paperContainerClass,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  isSubmitting,
}) => {
  return (
    <Paper
      variant="outlined"
      classes={{
        root: paperContainerClass
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormInput
            formName="idTipoDireccionTrabajo"
            label="Tipo Direccion"
            value={values.idTipoDireccionTrabajo}
            onChange={handleChange("idTipoDireccionTrabajo")}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            select
            disabled={isSubmitting}
          >
            {tiposDireccion.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
              >
                {option.label}
              </MenuItem>
            ))}
          </FormInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="barrioComunidadTrabajo"
            label="Barrio/Comunidad"
            value={values.barrioComunidadTrabajo}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="direccionTrabajo"
            label="Dirección"
            value={values.direccionTrabajo}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="referenciaTrabajo"
            label="Referencia"
            value={values.referenciaTrabajo}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="sectorTrabajo"
            label="Sector"
            value={values.sectorTrabajo}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="telefonoConvencionalT"
            label="Telefono Convencional"
            value={values.telefonoConvencionalT}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            formName="telefonoCelularT"
            label="Telefono Celular"
            value={values.telefonoCelularT}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <FormInput
            formName="lugarTrabajo"
            label="Lugar Trabajo"
            value={values.lugarTrabajo}
            onChange={handleChange}
            onBlur={handleBlur}
            touched={touched}
            errors={errors}
            disabled={isSubmitting}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default TrabajoSection;
